import React, { useState, useContext, useEffect } from "react";
import AppContext from "context/Context";
import { Accordion, Card, Col, Container, Form, Row } from "react-bootstrap";
import NavbarStandard from "./NavbarStandard";
import { useTranslation } from "react-i18next";
import Footer from "./Footer";
import styles from "./landing.module.css";
import createMarkup from "helpers/createMarkup";
import { getAllDatabaseRecords } from "components/workflow/WorkflowHelper";
import LandingBackground from "assets/img/landing_background_bottom.jpg";
import LandingButtons from "./LandingButtons";
import BreadCrums from "./BreadCrums";
import PageTitle from "components/common/PageTitle";
import { GetAboutUs } from "common/general";

document.addEventListener("DOMContentLoaded", function () {
	const cssToRemove = document.getElementById("css-to-remove");
	if (cssToRemove) {
		cssToRemove.parentNode.removeChild(cssToRemove);
	}
});
const AboutUs = () => {
	const {
		config: { isDark, isRTL },
	} = useContext(AppContext);
	const [aboutUs, setAboutUs] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await GetAboutUs();

				if (response?.data?.dataBaseContent) {
					const mappedData = response.data.dataBaseContent.map((item) => ({
						title: t(item.aboutTitle),
						aboutText: t(item.aboutText),
					}));

					setAboutUs((prev) => [...prev, ...mappedData]);
				} else {
					console.error("Invalid response structure:", response);
				}
			} catch (error) {
				console.error("Error fetching about data:", error);
			}
		};

		fetchData();
	}, []);
	const [t, i18n] = useTranslation();
	return (
		<div className={`${styles.backgroundWhite} `}>
			<div
				style={{
					//backgroundImage: `url(${LandingBackground})`,
					backgroundSize: "cover",
					backgroundPosition: "top",
					justifyContent: "center",
				}}
			>
				<Container>
					{aboutUs.map((text, index) => (
						<div key={index}>
							<PageTitle menuName={text.title} />
							<div className={`${styles.accordionStyle} ${styles.size18}`} dangerouslySetInnerHTML={createMarkup(text.aboutText)} />
						</div>
					))}
				</Container>
				<LandingButtons textColor="#000000" />
			</div>
		</div>
	);
};

export default AboutUs;
